<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo, memberName} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts.js";
    import Modal from '../components/modal/Modal.svelte';
    import MemberControl from "../components/controls/MemberControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let member = null;
    export let closeCallback;

    const ACTIONS = {
        ADD: 1,
        REMOVE: 2,
        TRANSFER: 3
    }

    let points = 0;
    let reason = '';
    let maxPoints = 10000;
    let dstMember = null;
    let is_visible = 1;
    let action_id = ACTIONS.ADD;
    let actions = [
        {id: ACTIONS.ADD, name: 'Add points'},
        {id: ACTIONS.REMOVE, name: 'Remove points'},
        {id: ACTIONS.TRANSFER, name: 'Transfer points'}
    ];
    let labels = [
        'Points to add',
        'Points to remove',
        'Points to transfer'
    ];

    let buttons = [
        'Add',
        'Remove',
        'Transfer'
    ];


    const save = () => {

        const onSuccess = result => {
            let message = '';
            let points = Math.abs(result.points);
            if (result.action_id == ACTIONS.ADD) {
                message = `${result.points} points added to member.`;
            } else if (result.action_id == ACTIONS.REMOVE) {
                message = `${points} points removed from member.`;
            } else {
                message = `${points} points transferred from <b>${memberName(member)}</b> to <b>${memberName(dstMember)}</b>.`;
            }
            Alert.alert("Member points", message);
            closeCallback(true);
        }

        const onFailure = err => {
            if (err.code == 'field_invalid') {
                if (err.params === 'points') {
                    Alert.warning("Member points", "Too many points!", () => setFocusTo('points'));
                    return;
                }
            }
        };

        let errors = [
            "Enter the number of points to add to the member!",
            "Enter the number of points to remove from the member!",
            "Enter the number of points to transfer to the member!"
        ];

        points = ~~points;
        if (!points) {
            Notifier.showError(errors[action_id - 1]);
            setFocusTo('points')
            return;
        }

        reason = reason.trim();
        if (!reason) {
            Notifier.showError("Type the reason for this action!");
            setFocusTo('reason')
            return;
        }

        let apiPoint = '';
        let data = {
            member_id: member.id,
            action_id,
            points,
            reason,
            is_visible
        };
        if (action_id == ACTIONS.ADD) {
            apiPoint = 'addPoints';
        } else if (action_id == ACTIONS.REMOVE) {
            apiPoint = 'removePoints';
        } else {
            apiPoint = 'transferPoints';
            if (!dstMember) {
                Alert.warning("Member points", "Select the member to transfer the points to!", () => setFocusTo("dstMember"));
                return;
            }

            data.associated_member_id = dstMember.id;
        }

        R.handle(R.member[apiPoint], data, onSuccess, onFailure, LOADER.POPUP);
    }

    const onMemberChange = ({detail}) => {
        dstMember = detail;
    }

    const close = (param) => {
        member = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    if (!member.total_points) {
        actions = actions.filter(x => x.id == 1);
    } else {
        maxPoints = member.total_points;
    }

    $: if (member) {
        if (action_id != ACTIONS.REMOVE) {
            dstMember = null;
        }
        if (action_id != ACTIONS.ADD) {
            if (points > member.total_points) {
                points = member.total_points;
            }
        }
    }
</script>

{#if member}
    <Modal title="Member points" on:close="{ close }">
        <div slot="body">
            <h6 class="mb-3">{ member.lastname } { member.firstname }</h6>
            <div class="form-group">
                <div class="mb-2">
                    Total points:
                    {#if member.total_points}
                        <strong>{ member.total_points }</strong>
                    {:else}
                        <span class="text-danger">no points</span>
                    {/if}
                </div>
                <select class="form-select" bind:value="{ action_id }">
                    {#each actions as action}
                        <option value="{ action.id }">{ action.name }</option>
                    {/each}
                </select>
            </div>
            <div class="form-group">
                <label>{ labels[action_id - 1] }</label>
                <input type="number" class="form-control" id="points" min="0" max="{ maxPoints }"
                       bind:value="{ points }">
            </div>
            {#if action_id == ACTIONS.TRANSFER}
                <div class="form-group">
                    <label>Select member to transfer points to</label>
                    <MemberControl id="dstMember" placeholder="name or email" on:change={ onMemberChange }/>
                </div>
            {/if}
            <div class="form-group">
                <label>Reason</label>
                <textarea class="form-control" id="reason" bind:value="{ reason }"></textarea>
            </div>
            <div class="form-group">
                <Checkbox label="Visible to member" bind:checked="{ is_visible }"/>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">{ buttons[action_id - 1] }</button>
            </div>
        </div>
    </Modal>
{/if}

